import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

const STORAGE_KEY = 'generatedEventId'

export const useGeneratedEventId = () => {
    const [eventId, setEventId] = useState<string | undefined>(() => {
        const stored = sessionStorage.getItem(STORAGE_KEY)
        return stored || undefined
    })

    const generateEventId = () => {
        if (!eventId) {
            const newId = uuidv4()
            sessionStorage.setItem(STORAGE_KEY, newId)
            setEventId(newId)
        }
    }

    const clearGeneratedEventId = () => {
        sessionStorage.removeItem(STORAGE_KEY)
        setEventId(undefined)
    }

    return { generatedEventId: eventId, generateEventId, clearGeneratedEventId }
}
